import { RaffleParticipant } from "@/apps/raffle/types";

export const CENTER = 200;
export const RADIUS = 188;
export const LABEL_PADDING = 12;
export const MAX_LABEL_FONT_SIZE = 16;
export const WHEEL_SIZE = CENTER * 2;
export const RIM_WIDTH = CENTER - RADIUS;
export const WHITE_RIM_WIDTH = 8;
export const HORIZONTAL_SAFE_GAP = 48;
export const PIN_SIZE = 124;
export const PIN_SMALL_Y_OFFSET = 16;

export type WheelSector = {
  participant: RaffleParticipant;
  sectorAngle: number;
  startAngle: number;
  endAngle: number;
  midAngle: number;
};

export const polarToCartesian = (
  angle: number,
  radius: number,
  center: number
) => {
  const radians = ((angle - 90) * Math.PI) / 180;

  return {
    x: center + radius * Math.cos(radians),
    y: center + radius * Math.sin(radians),
  };
};

export const createSectorPath = (
  startAngle: number,
  endAngle: number,
  radius: number,
  center: number
) => {
  const start = polarToCartesian(startAngle, radius, center);
  const end = polarToCartesian(endAngle, radius, center);
  const largeArcFlag = endAngle - startAngle > 180 ? 1 : 0;

  return [
    `M ${center} ${center}`,
    `L ${start.x} ${start.y}`,
    `A ${radius} ${radius} 0 ${largeArcFlag} 1 ${end.x} ${end.y}`,
    "Z",
  ].join(" ");
};

export const getOriginalAngles = (participants: RaffleParticipant[]) => {
  const totalRides = participants.reduce(
    (sum, participant) => sum + participant.rides,
    0
  );
  const fallbackAngle = participants.length > 0 ? 360 / participants.length : 0;

  return participants.map((participant) =>
    totalRides > 0 ? (participant.rides / totalRides) * 360 : fallbackAngle
  );
};

export const buildSectors = (participants: RaffleParticipant[]) => {
  const originalAngles = getOriginalAngles(participants);
  let sectorStartAngle = 0;

  return participants.map<WheelSector>((participant, index) => {
    const sectorAngle = originalAngles[index];
    const startAngle = sectorStartAngle;
    const endAngle = startAngle + sectorAngle;
    const midAngle = startAngle + sectorAngle / 2;

    sectorStartAngle = endAngle;

    return {
      participant,
      sectorAngle,
      startAngle,
      endAngle,
      midAngle,
    };
  });
};
